export function humanizedEnvironment(environment) {
  switch (environment) {
    case 'staging':
      return 'EU Staging';
    case 'production':
      return 'EU Production';
    case 'us_staging':
      return 'US Staging';
    case 'us_production':
      return 'US Production';
    case 'development':
      return 'Development';
    default:
      return null;
  }
}
